// extracted by mini-css-extract-plugin
export var rule__subtitle = "rule-module--rule__subtitle--KP7D5";
export var rule__content = "rule-module--rule__content--3ONJu";
export var rule__content__i_2em = "rule-module--rule__content__i_2em--3Di2y";
export var rule__content__i_3em = "rule-module--rule__content__i_3em--2N6IZ";
export var rule__content__indent = "rule-module--rule__content__indent--4M7Jw";
export var rule__heading = "rule-module--rule__heading--3Xw2N";
export var rule__small = "rule-module--rule__small--1MVXb";